// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--2Z4DX","tab":"a10a3f92e9--tab--2XwYf","active":"a10a3f92e9--active--guBy9"};